import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyJobChange, HttpResponse } from "@/types";

export function useGetCandidacyJobChanges({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "candidacy-job-changes",
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy-job-changes`;
      const res = await guacHttpClient.get<
        CandidacyJobChange[],
        HttpResponse<CandidacyJobChange[]>
      >(path);
      return res.data;
    },
  });
}
